import axiosClient from 'api/axiosClient';
import LandownerElectricityPaymentHistoryView from 'features/ManageLandowner/components/LandownerElectricityPaymentHistoryView';
import KTBSCard from 'general/components/OtherKeenComponents/KTBSCard';
import Global from 'general/utils/Global';
import Utils from 'general/utils/Utils';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function ElectricityPaymentListScreen(props) {
  const { user } = useSelector((state) => state.auth);
  const [electricityPaymentHistoryList, setElectricityPaymentHistoryList] = useState([]);
  const [electricityPaymentHistoryListPagination, setElectricityPaymentHistoryListPagination] =
    useState({});
  const [filter, setFilter] = useState(Global.g_filterElectricityPaymentList);

  useEffect(() => {
    getEnergyBillList();
  }, [filter]);

  const getEnergyBillList = async () => {
    const res = await axiosClient.get('/energyBill', {
      params: { agencyId: user?.agency?.agencyId, ...Utils.filterParams(filter) },
    });
    const { result, energyBills, total } = res;
    if (result === 'success') {
      setElectricityPaymentHistoryList(energyBills);
      setElectricityPaymentHistoryListPagination({ total });
    }
  };

  return (
    <KTBSCard
      borderRadius={10}
      body={
        <LandownerElectricityPaymentHistoryView
          showFullUI={true}
          items={electricityPaymentHistoryList}
          pagination={electricityPaymentHistoryListPagination}
          filter={filter}
          onFilterChanged={(filter) => {
            Global.g_filterElectricityPaymentList = {
              ...Global.g_filterElectricityPaymentList,
              ...filter,
            };
            setFilter(Global.g_filterElectricityPaymentList);
          }}
          onDeleteItem={(row) => { }}
          handleGetEnergyBillList={getEnergyBillList}
        />
      }
    />
  );
}

export default ElectricityPaymentListScreen;
